import { defineStore } from 'pinia';
import axios from 'axios';

import { storeToRefs } from 'pinia';
import { useKeywordsStore } from '@/store/visibility/keywords';
import { resolveCreationDate } from '@/utils/geo/dateRanges';

export const useDashboardGeoStore = defineStore('dashboardGeo', {
	state: () => ({
		loading: false,
		error: null,

		_inflightRequests: {},
		_inflightMarketLabel: {},
		_initializingMarketLabelKey: null,
		_lastNamesKey: null,

		currentMarketId: null,
			currentCreationDate: null,
			aiOverviewTriggerStats: {
				triggered_count: 0,
				processed_count: 0,
				snapshot_creation_date: null,
				snapshot_creation_date_day: null,
			},

		actors: [],
		labels: [],
		keyBenefitLabels: [],
		labelQuestions: [],
		labelKeywords: [],
		selectedLabelIds: [],

		scores: {
				ai_overview: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0,
					top_url: []
				},
				chatgpt: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0,
					top_url: []
				},
				global: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0,
					top_url: []
				},
				ai_mode: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0,
					top_url: []
				},
				perplexity: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0,
					top_url: []
				}
		},
		last_scores: {
				ai_overview: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0
				},
				chatgpt: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0
				},
				global: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0
				},
				ai_mode: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0
				},
				perplexity: {
					n_mentions: 0,
					visibility_score: 0,
					share_of_voice_evolution: {},
					share_of_voice_by_actor: {},
					share_of_voice_donut: [],
					share_of_voice_full_list: [],
					n_mentions_by_actor: {},
					n_source_by_actor: {},
					n_analysed_text: 0
				}
		},

		analysis: {
			ai_overview: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			chatgpt: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			global: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			ai_mode: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			perplexity: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			}
		},
		last_analysis: {
			ai_overview: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			chatgpt: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			global: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			ai_mode: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			},
			perplexity: {
				labels_donut: [],
				best_label: {},
				best_driver: {},
				drivers_analysis: [],
			}
		},

		sentiments: {
			ai_overview: { sentiment_by_actor: {} },
			chatgpt: { sentiment_by_actor: {} },
			global: { sentiment_by_actor: {} },
			ai_mode: { sentiment_by_actor: {} },
			perplexity: { sentiment_by_actor: {} }
		},
		last_sentiments: {
			ai_overview: { sentiment_by_actor: {} },
			chatgpt: { sentiment_by_actor: {} },
			global: { sentiment_by_actor: {} },
			ai_mode: { sentiment_by_actor: {} },
			perplexity: { sentiment_by_actor: {} }
		},

		dates: [],
		selectedDate: [],
	}),

	getters: {
		actorById: (state) => (id) => {
			const actor = state.actors.find(a => a.id === parseInt(id));
			return actor ? actor.name : `Actor ${id}`;
		},

		shareOfVoiceData: (state) => (aiType = 'global') => {
			const data = state.scores[aiType]?.share_of_voice_by_actor || {};
			return state.actors.map(actor => ({
				id: actor.id,
				name: actor.name,
				color: actor.color,
				value: data[actor.id] || 0
			}));
		},

		evolutionData: (state) => (aiType = 'global') => {
			const data = state.scores[aiType]?.share_of_voice_evolution || {};
			return Object.entries(data)
				.map(([date, value]) => ({ date, value }))
				.sort((a, b) => new Date(a.date) - new Date(b.date));
		},

		competitiveLandscapeData: (state) => (aiType = 'global') => {
			const shareOfVoice = state.scores[aiType]?.share_of_voice_by_actor || {};
			const sentiments = state.sentiments[aiType]?.sentiment_by_actor || {};
			const bestLabels = state.analysis[aiType]?.best_label || {};
			
			return state.actors.map(actor => ({
				id: actor.id,
				name: actor.name,
				color: actor.color,
				shareOfVoice: shareOfVoice[actor.id] || 0,
				sentiment: sentiments[actor.id]?.sentiment || 'Neutre',
				ton: sentiments[actor.id]?.ton || 'Neutre',
				label: bestLabels[actor.id] || 'N/A',
			}));
		},

		brandPerformanceData: (state) => (aiType = 'global') => {
			const shareOfVoice = state.scores[aiType]?.share_of_voice_by_actor || {};
			const mentions = state.scores[aiType]?.n_mentions_by_actor || {};
			const sources = state.scores[aiType]?.n_source_by_actor || {};
			
			return state.actors.map(actor => ({
				id: actor.id,
				name: actor.name,
				color: actor.color,
				shareOfVoice: shareOfVoice[actor.id] || 0,
				mentions: mentions[actor.id] || 0,
				sources: sources[actor.id] || 0
			}));
		},

		evolutionTrends: (state) => {
			const getVisibilityDelta = (currentScore, previousScore) => {
				const current = currentScore?.visibility_score ?? 0;
				const previous = previousScore?.visibility_score ?? 0;
				return Math.round((current - previous) * 100);
			};

			const chatgptTrend = getVisibilityDelta(state.scores?.chatgpt, state.last_scores?.chatgpt);
			const globalTrend = getVisibilityDelta(state.scores?.global, state.last_scores?.global);
			const aiModeTrend = getVisibilityDelta(state.scores?.ai_mode, state.last_scores?.ai_mode);
			const perplexityTrend = getVisibilityDelta(state.scores?.perplexity, state.last_scores?.perplexity);

				const aiOverviewTrend = getVisibilityDelta(state.scores?.ai_overview, state.last_scores?.ai_overview);
				const fallbackTrends = [chatgptTrend, aiModeTrend, perplexityTrend, aiOverviewTrend];
				const nonZeroFallback = fallbackTrends.filter(value => value !== 0);
			const fallbackOverall = nonZeroFallback.length > 0
				? Math.round(nonZeroFallback.reduce((sum, value) => sum + value, 0) / nonZeroFallback.length)
				: 0;

			return {
				chatgpt: chatgptTrend,
					global: globalTrend,
					overall: globalTrend !== 0 ? globalTrend : fallbackOverall,
					aiOverview: aiOverviewTrend,
					aiMode: aiModeTrend,
					perplexity: perplexityTrend,
				};
		},
		lastEvolutionTrends: () => {
			return {
				chatgpt: 0,
					global: 0,
					overall: 0,
					aiOverview: 0,
					aiMode: 0,
					perplexity: 0,
				};
		},
	},

	actions: {
		async fetchAllGeoData(marketId, fetch_dates = true) {

			const KeywordsStore = useKeywordsStore();
			const { selectedCompetitorsLabel } = storeToRefs(KeywordsStore);
			const competitorLabelId = selectedCompetitorsLabel.value;

			let options = { fetchDates: true };
			if (typeof fetch_dates === 'boolean') {
				options.fetchDates = fetch_dates;
			}
			else if (fetch_dates && typeof fetch_dates === 'object') {
				options = { ...options, ...fetch_dates };
			}
			else {
				options.fetchDates = false;
			}

			this.loading = true;
			this.error = null;
			this.currentMarketId = marketId;

			const labelKey = (this.selectedLabelIds || []).slice().sort((a, b) => a - b).join(',') || 'all';
			const marketLabelKey = `${marketId}::${competitorLabelId ?? 'null'}::${labelKey}`;
			if (this._inflightMarketLabel[marketLabelKey] && (options.fetchDates || this._initializingMarketLabelKey === marketLabelKey)) {
				try {
					return await this._inflightMarketLabel[marketLabelKey];
				}
				finally {
					if (this.selectedDate.length > 0) {
						this.loading = false;
					}
				}
			}

			const startDateStr = this.changeDateToString(this.selectedDate?.[0]);
			const endDateStr = this.changeDateToString(this.selectedDate?.[1]);
			const inflightKey = `${marketId}::${competitorLabelId ?? 'null'}::${labelKey}::${startDateStr ?? 'null'}::${endDateStr ?? 'null'}`;
			if (this._inflightRequests[inflightKey]) {
				try {
					return await this._inflightRequests[inflightKey];
				}
				finally {
					if (this.selectedDate.length > 0) {
						this.loading = false;
					}
				}
			}

			const run = (async () => {
				if (options.fetchDates) {
					this._initializingMarketLabelKey = marketLabelKey;
				}
				if (options.fetchDates) {
					await this.fetchAIDates(marketId, competitorLabelId);
				}

				const namesKey = `${marketId}::${competitorLabelId ?? 'null'}::${labelKey}`;
				const shouldFetchNames = this._lastNamesKey !== namesKey;
				if (shouldFetchNames) {
					this._lastNamesKey = namesKey;
				}

				const tasks = [];
				if (shouldFetchNames) {
					tasks.push(this.fetchGeoNames(marketId, competitorLabelId));
				}
					tasks.push(this.fetchGeoScores(marketId, competitorLabelId));
					tasks.push(this.fetchAiOverviewTriggerStats(marketId));
					tasks.push(this.fetchGeoAnalysis(marketId, competitorLabelId));
					tasks.push(this.fetchGeoSentiments(marketId, competitorLabelId));

				await Promise.all(tasks);
			})();

			this._inflightMarketLabel[marketLabelKey] = run;
			this._inflightRequests[inflightKey] = run;
			try {
				await run;
			}
			catch (error) {
				this.error = error.message;
				console.error('Error fetching geo data:', error);
				throw error;
			}
			finally {
				delete this._inflightRequests[inflightKey];
				delete this._inflightMarketLabel[marketLabelKey];
				if (this._initializingMarketLabelKey === marketLabelKey) {
					this._initializingMarketLabelKey = null;
				}
				if (this.selectedDate.length > 0) {
					this.loading = false;
				}
			}
		},

		async fetchAIDates(marketId, selectedCompetitorsLabel = null) {
			const response = await axios.post(
				'vuejs/get_dashboard_geo_dates',
				{
					market_id: marketId,
					competitor_label_id: selectedCompetitorsLabel,
				},
				{ withCredentials: true },
			);

			if (response.data.success) {
				this.dates = response.data.data;
				let defaultSelection = [];

				if (this.dates.length >= 2) {
					defaultSelection = [this.dates[this.dates.length - 2], this.dates[this.dates.length - 1]];
				}
				else {
					defaultSelection = [this.dates[0], this.dates[0]];
				}

				defaultSelection = defaultSelection.map(ts => {
					const timestampMs = ts < 10000000000 ? ts * 1000 : ts;
					return new Date(timestampMs);
				});

				if (defaultSelection) {
					this.selectedDate = defaultSelection;
				}
			}
		},

		async fetchGeoNames(marketId, selectedCompetitorsLabel = null) {
			const response = await axios.post('vuejs/geo_names',
				{
					market_id: marketId,
					competitor_label_id: selectedCompetitorsLabel,
					label_ids: this.selectedLabelIds,
				},
				{ withCredentials: true }
			);

				if (response.data.success) {
					this.actors = response.data.data.actors || [];
					this.labels = response.data.data.labels || [];
					this.keyBenefitLabels = response.data.data.key_benefit_labels || [];
					this.labelQuestions = response.data.data.label_questions || [];
					this.labelKeywords = response.data.data.label_keywords || [];
				} else {
					throw new Error('Failed to fetch geo names data');
				}

			return response.data.data;
		},

			async fetchGeoScores(marketId, selectedCompetitorsLabel = null) {
			const startCreationDate = resolveCreationDate(this.selectedDate[0], this.dates);
			const endCreationDate = resolveCreationDate(this.selectedDate[1], this.dates);
			const response = await axios.post('vuejs/geo_scores',
				{
					market_id: marketId,
					start_date: startCreationDate ?? this.changeDateToString(this.selectedDate[0]),
					end_date: endCreationDate ?? this.changeDateToString(this.selectedDate[1]),
					competitor_label_id: selectedCompetitorsLabel,
					label_ids: this.selectedLabelIds,
				},
				{ withCredentials: true }
			);

			if (response.data.success) {
				this.scores = {
					ai_overview: response.data.data.end_date.ai_overview || this.scores.ai_overview,
					chatgpt: response.data.data.end_date.chatgpt || this.scores.chatgpt,
					global: response.data.data.end_date.global || this.scores.global,
					ai_mode: response.data.data.end_date.ai_mode || this.scores.ai_mode,
					perplexity: response.data.data.end_date.perplexity || this.scores.perplexity
				};
				this.last_scores = {
					ai_overview: response.data.data.start_date.ai_overview || this.last_scores.ai_overview,
					chatgpt: response.data.data.start_date.chatgpt || this.last_scores.chatgpt,
					global: response.data.data.start_date.global || this.last_scores.global,
					ai_mode: response.data.data.start_date.ai_mode || this.last_scores.ai_mode,
					perplexity: response.data.data.start_date.perplexity || this.last_scores.perplexity
				};
			}
			else {
				throw new Error('Failed to fetch geo scores data');
			}

				return response.data.data;
			},

			async fetchAiOverviewTriggerStats(marketId) {
				const response = await axios.post(
					'vuejs/get_ai_overview_trigger_stats',
					{
						market_id: marketId,
						date_range_end: this.changeDateToString(this.selectedDate?.[1]),
					},
					{ withCredentials: true }
				);

				if (response.data.success) {
					this.aiOverviewTriggerStats = {
						triggered_count: Number(response.data?.data?.triggered_count) || 0,
						processed_count: Number(response.data?.data?.processed_count) || 0,
						snapshot_creation_date: response.data?.data?.snapshot_creation_date ?? null,
						snapshot_creation_date_day: response.data?.data?.snapshot_creation_date_day ?? null,
					};
				} else {
					throw new Error('Failed to fetch AI Overview trigger stats');
				}

				return response.data.data;
			},

		async fetchGeoAnalysis(marketId, selectedCompetitorsLabel = null) {
			const startCreationDate = resolveCreationDate(this.selectedDate[0], this.dates);
			const endCreationDate = resolveCreationDate(this.selectedDate[1], this.dates);
			const response = await axios.post('vuejs/geo_analysis',
				{
					market_id: marketId,
					start_date: startCreationDate ?? this.changeDateToString(this.selectedDate[0]),
					end_date: endCreationDate ?? this.changeDateToString(this.selectedDate[1]),
					competitor_label_id: selectedCompetitorsLabel,
					label_ids: this.selectedLabelIds,
				},
				{ withCredentials: true }
			);

			if (response.data.success) {
				this.analysis = {
					ai_overview: response.data.data.end_date.ai_overview || this.analysis.ai_overview,
					chatgpt: response.data.data.end_date.chatgpt || this.analysis.chatgpt,
					global: response.data.data.end_date.global || this.analysis.global,
					ai_mode: response.data.data.end_date.ai_mode || this.analysis.ai_mode,
					perplexity: response.data.data.end_date.perplexity || this.analysis.perplexity
				};
				this.last_analysis = {
					ai_overview: response.data.data.start_date.ai_overview || this.last_analysis.ai_overview,
					chatgpt: response.data.data.start_date.chatgpt || this.last_analysis.chatgpt,
					global: response.data.data.start_date.global || this.last_analysis.global,
					ai_mode: response.data.data.start_date.ai_mode || this.last_analysis.ai_mode,
					perplexity: response.data.data.start_date.perplexity || this.last_analysis.perplexity
				};
			}
			else {
				throw new Error('Failed to fetch geo analysis data');
			}

			return response.data.data;
		},

		async fetchGeoSentiments(marketId, selectedCompetitorsLabel = null) {
			const startCreationDate = resolveCreationDate(this.selectedDate[0], this.dates);
			const endCreationDate = resolveCreationDate(this.selectedDate[1], this.dates);
			const response = await axios.post('vuejs/geo_sentiments', 
				{
					market_id: marketId,
					start_date: startCreationDate ?? this.changeDateToString(this.selectedDate[0]),
					end_date: endCreationDate ?? this.changeDateToString(this.selectedDate[1]),
					competitor_label_id: selectedCompetitorsLabel,
					label_ids: this.selectedLabelIds,
				},
				{ withCredentials: true }
			);

			if (response.data.success) {
				this.sentiments = {
					ai_overview: response.data.data.end_date.ai_overview || this.sentiments.ai_overview,
					chatgpt: response.data.data.end_date.chatgpt || this.sentiments.chatgpt,
					global: response.data.data.end_date.global || this.sentiments.global,
					ai_mode: response.data.data.end_date.ai_mode || this.sentiments.ai_mode,
					perplexity: response.data.data.end_date.perplexity || this.sentiments.perplexity
				};
				this.last_sentiments = {
					ai_overview: response.data.data.start_date.ai_overview || this.last_sentiments.ai_overview,
					chatgpt: response.data.data.start_date.chatgpt || this.last_sentiments.chatgpt,
					global: response.data.data.start_date.global || this.last_sentiments.global,
					ai_mode: response.data.data.start_date.ai_mode || this.last_sentiments.ai_mode,
					perplexity: response.data.data.start_date.perplexity || this.last_sentiments.perplexity
				};
			}
			else {
				throw new Error('Failed to fetch geo sentiments data');
			}

			return response.data.data;
		},

		// async refreshDataForDate(marketId, dateString) {
		// 	this.currentCreationDate = null;
		// 	await this.fetchAllGeoData(marketId, dateString);
		// },

		clearData() {
			this.actors = [];
			this.labels = [];
			this.keyBenefitLabels = [];
			this.labelQuestions = [];
			this.labelKeywords = [];
			this.selectedLabelIds = [];
			this.scores = {
				ai_overview: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0, top_url: [] },
				chatgpt: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0, top_url: [] },
				global: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0, top_url: [] },
				ai_mode: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0, top_url: [] },
				perplexity: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0, top_url: [] }
			};
			this.last_scores = {
				ai_overview: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0 },
				chatgpt: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0 },
				global: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0 },
				ai_mode: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0 },
				perplexity: { n_mentions: 0, visibility_score: 0, share_of_voice_evolution: {}, share_of_voice_by_actor: {}, share_of_voice_donut: [], share_of_voice_full_list: [], n_mentions_by_actor: {}, n_source_by_actor: {}, n_analysed_text: 0 }
			};
			this.analysis = {
				ai_overview: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				chatgpt: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				global: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				ai_mode: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				perplexity: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
			};
			this.last_analysis = {
				ai_overview: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				chatgpt: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				global: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				ai_mode: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
				perplexity: { labels_donut: [], best_label: {}, best_driver: {}, drivers_analysis: [] },
			};
			this.sentiments = {
				ai_overview: { sentiment_by_actor: {} },
				chatgpt: { sentiment_by_actor: {} },
				global: { sentiment_by_actor: {} },
				ai_mode: { sentiment_by_actor: {} },
				perplexity: { sentiment_by_actor: {} }
			};
			this.last_sentiments = {
				ai_overview: { sentiment_by_actor: {} },
				chatgpt: { sentiment_by_actor: {} },
				global: { sentiment_by_actor: {} },
				ai_mode: { sentiment_by_actor: {} },
				perplexity: { sentiment_by_actor: {} }
			};
				this.currentMarketId = null;
				this.currentCreationDate = null;
				this.aiOverviewTriggerStats = { triggered_count: 0, processed_count: 0, snapshot_creation_date: null, snapshot_creation_date_day: null };
				this.error = null;
			},

		clearError() {
			this.error = null;
		},

		changeDateToString(date) {
			if (date instanceof Date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			}
			return date;
		},
	},

	persist: false
});
